import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../constant";

const WishlistContext = createContext();

export const useWishlistContext = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const [wishlistCount, setWishlistCount] = useState(0);

  useEffect(() => {
    fetchWishlistCount();
  }, []);

  const fetchWishlistCount = async () => {
    try {
      const userId = localStorage.getItem("userId");
      let response = await axios.get(`${BASE_URL}/wishlist/get/${userId}`);
      if(response && response.response){
        setWishlistCount(0);
      }
      else
      setWishlistCount(response.data.length);
    } catch (error) {
      setWishlistCount(0);
    }
  };

  return (
    <WishlistContext.Provider value={{ wishlistCount, fetchWishlistCount }}>
      {children}
    </WishlistContext.Provider>
  );
};
